import { render } from "./AdsPackageEditing.vue?vue&type=template&id=57700790&ts=true"
import script from "./AdsPackageEditing.vue?vue&type=script&lang=ts"
export * from "./AdsPackageEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__